import { cn } from "@/common/utils";
import Typography from "@/components/Typography/Typography";
import { Card } from "antd";

export default function HeaderAddress({
  addressAData,
  addressBData,
  className,
  addressLineClassName,
}: {
  addressAData: any;
  addressBData?: any;
  generalQuoteData?: any;
  className?: string;
  addressLineClassName?: string;
}) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex justify-between gap-4 pt-3.5 px-4">
        <div
          className={cn(
            "",
            className,
            addressBData?.address ? "w-1/2" : "w-full"
          )}
        >
          <Card
            size="small"
            className={cn(
              "flex  justify-between w-full text-[14px] font-kanit font-light bg-primaryDim mt-3.5 ml-4 text-nowrap truncate !m-0",
              addressLineClassName
            )}
            styles={{
              body: {
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              },
            }}
          >
            <Typography
              type="span"
              textColor="blackTransparent-60"
              fontFamily="font-kanit"
            >
              A end Address:
            </Typography>
            <Typography
              type="span"
              textColor="black"
              fontFamily="font-kanit"
              fontWeight="font-light"
            >
              {addressAData.fullAddress}
            </Typography>
          </Card>
        </div>

        <div
          className={cn(
            "",
            className,
            addressBData?.address ? "w-1/2" : "w-full"
          )}
        >
          {addressBData?.address && (
            <Card
              size="small"
              className={cn(
                "flex  justify-between w-full text-[14px] font-kanit font-light bg-primaryDim mt-3.5 ml-4 text-nowrap truncate !m-0",
                addressLineClassName
              )}
              styles={{
                body: {
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                },
              }}
            >
              <Typography
                type="span"
                textColor="blackTransparent-60"
                fontFamily="font-kanit"
              >
                B end Address:
              </Typography>
              <Typography
                type="span"
                textColor="black"
                fontFamily="font-kanit"
                fontWeight="font-light"
              >
                {addressBData.fullAddress}
              </Typography>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
}
